import React, { useState, useContext, useEffect } from "react";
import UserContext from "../contexts/UserContext";

import { AiOutlineClose, AiOutlineMenu, AiFillAlert } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import config from "../config";

const Navbar = () => {
  const { authenticated, logout } = useContext(UserContext);
  const [nav, setNav] = useState(false);
  const primaryColor = config.env.primaryColor || "#00df9a";

  const { t, i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  useEffect(() => {
    // Update currentLanguage whenever i18n.language changes
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const browserLang = navigator.language.split('-')[0];
    const supportedLangs = ['en', 'fr', 'es', 'ne', 'de', 'it', 'po'];
    
    if (supportedLangs.includes(browserLang) && browserLang !== i18n.language) {
      i18n.changeLanguage(browserLang);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeLanguage = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
    setNav(!nav);
  };

  const handleNav = () => {
    setNav(!nav);
  };

  const company_name = config.appName || "To define";
  const phone = config.env.phone || "To define";

  const navigate = useNavigate();

  const handleSmoothScroll = (id) => {
    handleNav();
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="sticky top-0 z-30 bg-black">
      <div className="flex justify-between items-center h-24 max-w-[1240px] mx-auto px-4 text-white">
        <h1 className="text-3xl font-bold hover:text-indigo-400" style={{ color: primaryColor }}>
          {" "}
          <Link to="/" className="">
            {company_name}
          </Link>
        </h1>
        <ul className="hidden md:flex">
          <li className="p-4">
            <Link to="/#home">{t("Navbar.home")}</Link>
          </li>
          <li className="p-4">
            <Link to="/check">{t("Navbar.your_booking")}</Link>
          </li>
          <li className="p-4">
            <button onClick={() => handleSmoothScroll('about')}>{t("Navbar.about")}</button>
          </li>
          <li className="p-4">
            <button onClick={() => handleSmoothScroll('faq')}>{t("Navbar.faq")}</button>
          </li>
          <li className="p-4">
            <a href={`tel:${phone}`} className="inline-flex">
              <AiFillAlert size={20} color="red" />
              {t("Navbar.emergency")}
            </a>
          </li>
          {authenticated && (
            <li className="p-4">
              <Link to="/dashboard" className="text-black inline-flex " style={{ color: primaryColor }}>
                {t("Navbar.dashboard")}
              </Link>
            </li>
          )}
          <li className="my-auto px-2">
            <select
              className="cursor-pointer bg-transparent border border-gray-300 rounded p-2 transition duration-300 ease-in-out hover:bg-gray-600 hover:border-gray-600 hover:shadow-md"
              onChange={changeLanguage}
              value={currentLanguage}
            >
              <option value="en">English</option>
              <option value="fr">Français</option>
              <option value="es">Español</option>
              <option value="ne">Nederlands</option>
              <option value="de">Deutsch</option>
              <option value="it">Italiano</option>
              <option value="po">Português</option>
            </select>
          </li>
          <li className="my-auto">
            {authenticated ? (
              <button
                onClick={logout}
                className="bg-red-300 w-[115px] rounded-full font-medium  py-2 text-black hover:bg-indigo-400"
              >
                {t("Navbar.logout")}
              </button>
            ) : (
              <Link to="/login">
                <button className="w-[115px] rounded-full font-medium  py-2 text-black hover:bg-indigo-400" style={{ backgroundColor: primaryColor }}>
                  {t("Navbar.login")}
                </button>
              </Link>
            )}
          </li>
        </ul>

        <div onClick={handleNav} className="block md:hidden">
          {nav ? <AiOutlineClose size={20} /> : <AiOutlineMenu size={20} />}
        </div>
        <div
          className={
            nav
              ? "fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500 md:hidden"
              : "fixed left-[-100%]"
          }
        >
          <h1 className="w-full text-3xl font-bold hover:text-indigo-400" style={{ color: primaryColor }}>
            {company_name}
          </h1>
          <ul className="p-4 uppercase">
            <Link to="/#home" onClick={handleNav}>
              <li className="p-4 border-b border-gray-600">
                {t("Navbar.home")}
              </li>
            </Link>
            <Link to="/check" onClick={handleNav}>
              <li className="p-4 border-b border-gray-600">
                {t("Navbar.your_booking")}
              </li>
            </Link>
            <Link to="/#about" onClick={handleNav}>
              <li className="p-4 border-b border-gray-600">
                {t("Navbar.about")}
              </li>
            </Link>
            <Link to="/#faq" onClick={handleNav}>
              <li className="p-4 border-b border-gray-600">
                {t("Navbar.faq")}
              </li>
            </Link>
            <li className="p-4 border-b border-gray-600 inline-flex w-full">
              <a href={`tel:${phone}`} className="inline-flex">
                <AiFillAlert size={20} color="red" />
                {t("Navbar.emergency")}
              </a>
            </li>
            {authenticated && (
              <Link to="/dashboard" onClick={handleNav}>
                <li className="inline-flex w-full" style={{ color: primaryColor }}>
                  {t("Navbar.dashboard")}
                </li>
              </Link>
            )}
            <li className="p-4 border-b border-gray-600">
              <select
                className="w-full cursor-pointer bg-transparent border border-gray-300 rounded p-2 transition duration-300 ease-in-out hover:bg-gray-600 hover:border-gray-600 hover:shadow-md"
                onChange={changeLanguage}
                value={currentLanguage}
              >
                <option value="en">English</option>
                <option value="fr">Français</option>
                <option value="es">Español</option>
                <option value="ne">Nederlands</option>
                <option value="de">Deutsch</option>
                <option value="it">Italiano</option>
                <option value="po">Português</option>
              </select>
            </li>
            <Link to="/booking/departure" onClick={handleNav}>
              <li className="p-4 ">
                <button className=" w-full rounded-md font-medium  py-2 text-black hover:bg-indigo-400" style={{ backgroundColor: primaryColor }}>
                  {t("Navbar.button")}
                </button>
              </li>
            </Link>
            {authenticated ? (
              <li className="p-4 ">
                <button
                  onClick={logout}
                  className="bg-red-300 w-full rounded-md font-medium  py-2 text-black hover:bg-indigo-400"
                >
                  {t("Navbar.logout")}
                </button>
              </li>
            ) : (
              <Link to="/login" onClick={handleNav}>
                <li className="p-4 ">
                  <button className="w-full rounded-md font-medium  py-2 text-black hover:bg-indigo-400" style={{ backgroundColor: primaryColor }}>
                    {t("Navbar.login")}
                  </button>
                </li>
              </Link>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
